<div class="gup-C-benefPicker">

    <kal-input icon="keyboard_arrow_down"
               placeholder="Nom, Prénom ou Matricule"
               (focusin)="searchBeneficiary(control.value)"
               (iconClicked)="searchBeneficiary(control.value)"
               [label]="label"
               [formControl]="control"
               [kalAutocomplete]="displayedList"
               [kalSelectOnPick]="kalSelectOnPick"
               [kalAutocompleteOptionTemplate]="optionsTemplate"
               [kalAutocompleteLoading]="loading"
               [kalAutocompleteEmptyLabel]="emptyMessage"
               kalAutocompleteHeight="30vh"
               [kalClearOnPick]="clearOnPick"
               (kalAutocompleteSelected)="pickBenef($event)"
               (keyup.enter)="pickBenefFromKeyEvent()"
               (kalAutocompleteClosed)="clearBenef()">
    </kal-input>

    <ng-template #optionsTemplate let-option="option">
        <div class="optionsList" [class.gup-U-color--200]="!option.value.IsDroitsActifs">

            <span>
                {{ option.label + (!!option.matricule && showMatricules ? ' ('+option.matricule+')' : '')}}
            </span>
            <span *ngIf="!!option.matricule && kalSelectOnPick">{{option.matricule}}</span>

            <a *ngIf="!kalSelectOnPick" class="gup-O-link -secondary"
               (click)="addBeneficiary(option)">
                Ajouter
            </a>

        </div>
    </ng-template>

    <kal-checkbox label="Voir les bénéficiaires hors droits"
                  *ngIf="displayOutRightCheckbox"
                  [formControl]="outRightControl">
    </kal-checkbox>

</div>
